import { type ButtonHTMLAttributes, type ReactNode } from 'react';

export interface LoadingButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  loading?: boolean;
  loadingText?: string;
  children: ReactNode;
}

export default function LoadingButton({
  loading = false,
  loadingText,
  disabled,
  children,
  className = '',
  ...rest
}: LoadingButtonProps) {
  const isDisabled = loading || disabled;
  return (
    <button
      {...rest}
      disabled={isDisabled}
      aria-busy={loading || undefined}
      className={`${className} ${loading ? 'cursor-wait opacity-90' : ''} ${
        isDisabled ? 'disabled:opacity-60 disabled:cursor-not-allowed' : ''
      }`}
    >
      {loading ? (
        <span className="inline-flex items-center gap-2">
          <span
            className="inline-block h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent"
            aria-hidden="true"
          />
          <span>{loadingText ?? children}</span>
        </span>
      ) : (
        children
      )}
    </button>
  );
}
